'use strict';

wbApp.controller('DuePaymentAmortizationScheduleCtrl', ['$scope', '$window', '$translate', '$filter', 'paymentsSvc', 'securitySvc',
function ($scope, $window, $translate, $filter, paymentsSvc, securitySvc) {


    var isActive = false;
    var loaded = false;
    $scope.invoiceID = null;
    $scope.amortizationSchedules = [];

    $scope.$on('selectedDuePaymentChanged', function (e, data) {

        if (data) {
            if (data.invoiceID !== $scope.invoiceID || !loaded) {
                $scope.invoiceID = data.invoiceID;
                if (isActive) {
                    $scope.amortizationSchedules = paymentsSvc.getAmortizationScheduleDuePayments(data.invoiceID);
                    loaded = true;
                } else {
                    loaded = false;
                }
            }
        } else {
            $scope.amortizationSchedules.length = 0;
            loaded = false;
        }
    });


    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 5) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.invoiceID) {
                    $scope.amortizationSchedules = paymentsSvc.getAmortizationScheduleDuePayments($scope.invoiceID);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.amortizationSchedulesGridSettings = {
        name: 'amortizationSchedules',
        columns: [
            {
                dataField: 'amortizationScheduleNo',
                caption: $translate.instant("TXT_ORDER"),
                dataType: 'number',
                width: '90px',
                sortOrder: 'asc'
            },
            { dataField: 'issueAt', caption: $translate.instant('TXT_LBL_DATE'), dataType: 'date', width: '90px' },
            { dataField: 'amount', caption: $translate.instant('TXT_LBL_AMOUNT'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
           { dataField: 'arrear', caption: $translate.instant('TXT_LBL_ARREAR'), dataType: 'number', format: { type: 'currency', precision: 2 } }
        ]
    }
   
}]);